import React from 'react';

import {Title} from '@optimaxdev/design-system';

import s from './bannerTextBlock.scss';

export type PropsType = {
    bannerH1Text?: string;
    bannerH2Text?: string;
    bannerH1Color?: string;
    bannerH2Color?: string;
    isDark?: boolean;
};
/**
 * BannerText component
 */
export const BannerTextBlock: React.FC<PropsType> = ({
    bannerH1Color,
    bannerH1Text,
    bannerH2Color,
    bannerH2Text,
    isDark,
}) => {
    if (!bannerH1Text && !bannerH2Text) return null;
    const defaultColor = isDark ? '#0F0F0F' : 'white';

    return (
        <div className={s.container}>
            {bannerH1Text && (
                <Title className={s.bannerH1Text} color={bannerH1Color || defaultColor} level={1}>
                    {bannerH1Text}
                </Title>
            )}
            {bannerH2Text && (
                <Title className={s.bannerH2Text} color={bannerH2Color || defaultColor} level={2}>
                    {bannerH2Text}
                </Title>
            )}
        </div>
    );
};
